<template>
  <div class="volunteer_list">
            <div class="center">
                    <h5>Volunteer List</h5>
                    
            </div>
            <div class="row">
                <div class="col s2">
                    <back-container :link="'/volunteers/'+$route.params.township_id"></back-container>
                </div>
                <div class="input-field col s6">
                    <input  placeholder="Search here by phone,code,name" type="text" class="validate"
                     @keydown.enter="searchVolunteer" v-model="search"
                    >
                
                </div>
                 <div class="col s2 center">
                     <br/>
                    <button @click="excelExport" class="btn green darken-2">Excel Export</button>
                </div>
            </div>
            <div class="row center">
              
                <div class="card card-content " >
                    
                    <table class="app-table responsive-table">
                            <thead>
                            <tr>
                                <th>No</th><th>Name</th><th>Code</th><th>Phone</th>
                                <th>Village</th><th>Ward</th>
                                <th>Education</th><th>Occupation</th>
                                <th>Actions</th>
                                <th></th>
                            </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(volunteer,index) in volunteers">
                                    <td>{{ index+1 }}</td>
                                    <td>{{ volunteer.name }}</td>
                                    <td>{{ volunteer.code }}</td>
                                    <td>{{ volunteer.phone }}</td>
                                    <td>{{ volunteer.village }}</td>
                                    <td>{{ volunteer.ward }}</td>
                                    <td>{{ volunteer.education_status.name }}</td>
                                    <td>{{ volunteer.occupation.name }}</td>
                                    
                                    <td><router-link :to="{ name: 'VolunteerView', params: { id: volunteer.id } }"><i class="material-icons">navigate_next</i></router-link></td>
                                </tr>
                                
                            </tbody>
                            
                    </table>
                    <div class="row center" style="margin-top:10px;">
                              <loading v-if="loading"></loading>
                    </div>
                </div>
                <div class="row center" v-if="!loading && (volunteers.length<volunteer_count)">
                    <button class="btn blue darken-2" @click="loadMore">Load More</button>
                </div>
                     
              
                  
             </div>
         
      </div>
</template>

<script>
import Loading from '@/components/Partials/Loading.vue';
export default {
  name: 'VolunteerList',
  data () {
    return {
        search:"",
    }
  },
  mounted()
  {
      
    this.$store.dispatch("clearVolunteer");
    this.getData();
  },
  methods: {
    loadMore()
    {
        this.getData(true);
    },
    searchVolunteer()
    {
            
          this.$router.push({name:"VolunteerListSearch",params:{search:this.search}});

    },
    getData(load=false)
    {
         var data={
          lastid:0,
          load:load,
          township_id:this.$route.params.township_id
        };

        

        if (this.volunteers.length>0)
        {
            data.lastid=this.volunteers.length;
        }

        if (this.$route.params.search)
        {
            data.search=this.$route.params.search;
            
            
        }

        if (!data.load)
            {
                data.lastid=0;
            }

            
        
          this.$store.dispatch("getVolunteer",data);
    },
    excelExport()
    {
        this.$store.dispatch("exportVolunteerExcel",{id:this.$route.params.township_id});
    }
  },
  components: {
    "loading":Loading
  },
  computed:
  {
      volunteers()
      {
          return this.$store.getters.volunteers;
      },
      loading()
      {
          return this.$store.getters.volunteer_loading;
      },
      volunteer_count()
      {
          return this.$store.getters.volunteer_count;
      }
  },
   watch:{
    $route (to, from){
       this.getData();
     }
    } ,
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .volunteer_list 
  {
      padding-left:20px;
      padding-right:20px;
  }

  .volunteer_list .card-content 
  {
      padding:10px;
  }
</style>
